import { getApiBaseUrl } from "../data/authStorage";
import httpClient from "./httpClient";

const baseUrl = getApiBaseUrl();

export async function createHoliday(payload) {
  try {
    const response = await httpClient.post(
      `${baseUrl}/organizations/holidays`,
      payload,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

export async function listHolidays() {
  try {
    const response = await httpClient.get(`${baseUrl}/organizations/holidays`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

export async function listUpcomingHolidays(params = {}) {
  try {
    const { limit = 3 } = params;
    const response = await httpClient.get(
      `${baseUrl}/organizations/holidays/upcoming?limit=${limit}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

export async function getHolidayById(holidayId) {
  try {
    const response = await httpClient.get(
      `${baseUrl}/organizations/holidays/${holidayId}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

export async function updateHoliday(holidayId, payload) {
  try {
    const response = await httpClient.patch(
      `${baseUrl}/organizations/holidays/${holidayId}`,
      payload,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

export async function deleteHoliday(holidayId) {
  try {
    const response = await httpClient.delete(
      `${baseUrl}/organizations/holidays/${holidayId}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

export async function notifyHoliday(holidayId, payload = {}) {
  try {
    const response = await httpClient.post(
      `${baseUrl}/organizations/holidays/${holidayId}/notify`,
      payload,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}
